export const SPONSORSHIP_BONUS_AMOUNT = 3;
export const SPONSORSHIP_BONUS_PERCENT = 10;
export const SPONSORSHIP_PURCHASE_THRESHOLD = 20;

export const SPONSORSHIP_START_DATE = '01/10/2022';

export const SPONSORSHIP_IS_BOOSTED_OPERATION = false;
export const SPONSORSHIP_BOOSTED_OPERATION_END_DATE = '2022-09-30 23:59:59';
export const SPONSORSHIP_BOOSTED_BONUS_AMOUNT = 5;

export const SPONSORSHIP_SESSION_STORAGE_SPONSOR_KEY = 'sponsor';



// WEBPACK FOOTER //
// ./src/constants/sponsorship.js